import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import * as types from '../const/action.types';

import { setBluetooth } from './bluetooth.reducer';
import { basicInfo, sessionReducer, tutorial } from './session.reducer';
import { user, users, usersHasErrored, usersIsLoading } from './user.reducer';
import {
    dashboard,
    indicators,
    dashboardHasErrored,
    indicatorsHasErrored,
    dashboardIsLoading,
    charts,
} from './dashboard.reducer';
import { provider, providers, providersHasErrored, providersIsLoading } from './providers.reducer';
import {
    reference,
    references,
    referencesHasErrored,
    referencesIsLoading,
} from './references.reducer';
import { template, templates, templatesHasErrored, templatesIsLoading } from './templates.reducer';
import { client, clients, clientsHasErrored, clientsIsLoading } from './client.reducer';
import { display, displays, displaysHasErrored, displaysIsLoading } from './display.reducer';
import { machine, machines, machinesHasErrored, machinesIsLoading } from './machine.reducer';
import {
    local,
    localInfo,
    locals,
    localsHasErrored,
    localsIsLoading,
    localsInfo,
} from './locals.reducer';
import {
    typemachine,
    typemachines,
    typemachinesHasErrored,
    typemachinesIsLoading,
} from './type.machine.reducer';
import { employee, employees, employeesHasErrored, employeesIsLoading } from './employee.reducer';
import { rol, roles, roles_app, rolesHasErrored, rolesIsLoading } from './roles.reducer';
import {
    product,
    products,
    productsHasErrored,
    productsIsLoading,
    workstation,
} from './product.reducer';
import { forecast, forecasts, forecastsHasErrored, forecastsIsLoading } from './forecast.reducer';
import {
    xef,
    xefHasErrored,
    xefIsLoading,
    xefIsSaving,
    xefReferenceTime,
    xeflocal,
} from './xhef.reducer';
import { list, listsHasErrored, listsIsLoading } from './list.reducer';
import {
    termometre,
    termometres,
    termometresHasErrored,
    termometresIsLoading,
    termometresFields,
} from './termometre.reducer';
import version from './version.reducer';
import language from './language.reducer';
import { proccess, tools, searchArray, filter } from './process.home.reducer';
import inventory from './process.inventory.reducer';
import alert from './alert.warning.reducer';
import alertTabs from './alert.tabs.reducer';
import { alertList, alertIsLoading, alertIsSaving } from './alert.reducer';
import {
    processHasErrored,
    processIsLoading,
    setParameters,
    process,
    processMessages,
    instances_opened,
} from './api.process.reducer';
import {
    manualProcessHasErrored,
    manualProcessIsLoading,
    manualProcess,
} from './api.manual.process.reducer';
import {
    manageProcessHasErrored,
    manageProcessIsLoading,
    manage_process,
} from './api.manage.process.reducer';
import { reportSearchIsLoading, values, fields } from './api.reports.search.reducer';
import { reportLotIsLoading, lottemp } from './api.reports.lot.reducer';
import { reportAPPCCIsLoading, appcc } from './api.reports.appcc.reducer';
import { reportEmployeeIsLoading, report_employee } from './api.reports.employee.reducer';
import { reportSTSIsLoading, report_sts } from './api.reports.sts.reducer';
import {
    reportDecreaseIsLoading,
    reportDecrease,
    reportDecreaseLocals,
} from './api.reports.decrease.reducer';
import {
    manageFormHasErrored,
    manageFormIsLoading,
    manage_form,
    manageFormIsSaving,
} from './api.manage.form.reducer';
import { catalogHasErrored, catalogIsLoading, catalog, catalogs } from './api.catalog.reducer';
import {
    instanceHasErrored,
    instanceIsLoading,
    instance,
    last_instance_opened,
    instanceHandleChange,
    instanceSaveHasErrored,
    instanceIsSaving,
    instanceInExecution,
    instanceExecuteSuccess,
} from './api.form.reducer';
import { message, messages, messagesHasErrored, messagesIsLoading } from './message.reducer';
import {
    communication,
    communications,
    pendingMessages,
    setFilterCommunications,
    communicationsHasErrored,
    communicationsIsLoading,
} from './communication.reducer';
import { visibilityIsLoading, visibility, visibilityHasErrored } from './visibility.reducer';
import { STSIsLoading, STS, STSHasErrored } from './sts.reducer';
import {
    onboardingIsLoading,
    onboarding,
    onboardingHasErrored,
    onboarding_permission,
} from './onboarding.reducer';

const appReducer = combineReducers({
    xef,
    xef_has_error: xefHasErrored,
    xef_is_loading: xefIsLoading,
    xef_is_saving: xefIsSaving,
    xef_reference_time: xefReferenceTime,
    xeflocal,
    process_has_error: processHasErrored,
    process_is_loading: processIsLoading,
    process_paramters: setParameters,
    process,
    process_messages: processMessages,
    dashboard,
    dashboard_charts: charts,
    indicators,
    dashboard_has_error: dashboardHasErrored,
    indicators_has_error: indicatorsHasErrored,
    dashboard_is_loading: dashboardIsLoading,
    manual_process_has_error: manualProcessHasErrored,
    manual_process_is_loading: manualProcessIsLoading,
    manual_process: manualProcess,
    manage_process_has_error: manageProcessHasErrored,
    manage_process_is_loading: manageProcessIsLoading,
    manage_process,
    manage_form_is_saving: manageFormIsSaving,
    manage_form_has_error: manageFormHasErrored,
    manage_form_is_loading: manageFormIsLoading,
    manage_form,
    catalog_has_error: catalogHasErrored,
    catalog_is_loading: catalogIsLoading,
    catalogs,
    catalog,
    instance_in_execution: instanceInExecution,
    instance_execution: instanceExecuteSuccess,
    instance_save_has_error: instanceSaveHasErrored,
    instance_save_is_saving: instanceIsSaving,
    instance_has_error: instanceHasErrored,
    instance_is_loading: instanceIsLoading,
    instance_changes: instanceHandleChange,
    instance,
    instances_opened,
    last_instance_opened,
    form: reduxFormReducer,
    locales: language,
    window: proccess,
    window_tools: tools,
    window_searchs: searchArray,
    window_filter: filter,
    proccess_current_window: inventory,
    version: version,
    info: basicInfo,
    session: sessionReducer,
    users_has_errored: usersHasErrored,
    users_is_loading: usersIsLoading,
    users,
    user: user,
    providers_has_errored: providersHasErrored,
    providers_is_loading: providersIsLoading,
    providers,
    provider: provider,
    references_has_errored: referencesHasErrored,
    references_is_loading: referencesIsLoading,
    references,
    reference: reference,
    templates_has_errored: templatesHasErrored,
    templates_is_loading: templatesIsLoading,
    templates,
    template: template,
    report_search_is_loading: reportSearchIsLoading,
    report_search_is_values: values,
    report_search_is_fields: fields,
    report_decrease_is_loading: reportDecreaseIsLoading,
    report_decrease: reportDecrease,
    report_decrease_locals: reportDecreaseLocals,
    report_lot_is_loading: reportLotIsLoading,
    report_lot: lottemp,
    report_appcc_is_loading: reportAPPCCIsLoading,
    report_appcc: appcc,
    report_sts_is_loading: reportSTSIsLoading,
    report_sts,
    report_employee_is_loading: reportEmployeeIsLoading,
    report_employee: report_employee,
    display,
    displays,
    displays_has_errored: displaysHasErrored,
    displays_is_loading: displaysIsLoading,
    local,
    localInfo,
    localsInfo,
    locals,
    locals_has_errored: localsHasErrored,
    locals_is_loading: localsIsLoading,
    machine,
    machines,
    machines_has_errored: machinesHasErrored,
    machines_is_loading: machinesIsLoading,
    employee,
    employees,
    employees_has_errored: employeesHasErrored,
    employees_is_loading: employeesIsLoading,
    product,
    products,
    workstation,
    products_has_errored: productsHasErrored,
    products_is_loading: productsIsLoading,
    forecast,
    forecasts,
    forecasts_has_errored: forecastsHasErrored,
    forecasts_is_loading: forecastsIsLoading,
    list,
    lists_has_errored: listsHasErrored,
    lists_is_loading: listsIsLoading,
    type_machine: typemachine,
    type_machines: typemachines,
    type_machines_has_errored: typemachinesHasErrored,
    type_machines_is_loading: typemachinesIsLoading,
    termometre,
    termometres,
    termometres_has_errored: termometresHasErrored,
    termometres_is_loading: termometresIsLoading,
    termometres_fields: termometresFields,
    client,
    clients,
    clients_has_errored: clientsHasErrored,
    clients_is_loading: clientsIsLoading,
    bluetooth: setBluetooth,
    alert: alert,
    alertTabs: alertTabs,
    alerts: alertList,
    alert_is_loading: alertIsLoading,
    alert_is_saving: alertIsSaving,
    communication,
    communications,
    communications_pending: pendingMessages,
    communications_filter: setFilterCommunications,
    communications_has_errored: communicationsHasErrored,
    communications_is_loading: communicationsIsLoading,
    message,
    messages,
    messages_has_errored: messagesHasErrored,
    messages_is_loading: messagesIsLoading,
    visibility_is_loading: visibilityIsLoading,
    visibility,
    visibility_has_errored: visibilityHasErrored,
    sts_is_loading: STSIsLoading,
    sts: STS,
    sts_has_errored: STSHasErrored,
    rol,
    roles,
    roles_has_errored: rolesHasErrored,
    roles_is_loading: rolesIsLoading,
    roles_app: roles_app,
    onboarding_has_errored: onboardingHasErrored,
    onboarding_is_loading: onboardingIsLoading,
    onboarding,
    onboarding_permission,
    tutorial,
});

const rootReducer = (state, action) => {
    if (action.type === types.LOG_OUT) {
        state = {
            locales: state.locales,
        };
    }
    return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js